import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { grey } from "@mui/material/colors";

import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import FeedIcon from "@mui/icons-material/Feed";
import SyncIcon from "@mui/icons-material/Sync";
import Snackbar from "@mui/material/Snackbar";

import { getFormatedDateTime, getFormatedDate } from "../../Js/TimeAndDate";
import { fetchSiteConfig } from "../../Store/Slices/DefsSlice";
import {
  userLogs,
  getUserLogs,
  checkInternet,
  getLatestCustomerLicense,
  syncDatabase,
  productUpdateFromLive,
  productUpdateFromLocal,
  updateDefs,
  verifyProductData,
  fetchMedia,
} from "../../Js/Common";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

// import ProfilePageCard from "./ProfilePageCard";

const LicenseInfo = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig, serverRole } = useSelector((state) => state.defs);

  // State
  const [lastSyncDate, setLastSyncDate] = useState(null);

  const [stateSnackbar, setStateSnackbar] = useState({
    modalopen: false,
    vertical: "bottom",
    horizontal: "center",
    snackbarMessage: "",
  });
  const { vertical, horizontal, modalopen, snackbarMessage } = stateSnackbar;
  const [isColorFlag, setIsColorFlag] = useState(false);

  const [updateProductData, setUpdateProductData] = useState(null);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [productUpdateType, setProductUpdateType] = useState("local");
  // const [selectedProduct, setSelectedProduct] = useState(null);

  // const updateType = [{ "text": "Local", "value": "local" }, { "text": "Live", "value": "live" }];

  const [allMediaImported, setAllMediaImported] = useState(false);
  const [mediaVerifiedModal, setMediaVerifiedModal] = useState(false);
  const [progressBarPercent, setProgressBarPercent] = useState(0);

  useEffect(() => {
    const initialRender = async () => {
      let logName = await getLastSync();
      if (logName) {
        setLastSyncDate(logName.data.data[0].createdAt);
      }
    };
    if (
      serverRole !== "WEB_HOST" &&
      userInfo &&
      (userInfo.rolesInfo.title.toLowerCase() == "incharge" ||
        userInfo.rolesInfo.title.toLowerCase() == "admin")
    ) {
      initialRender();
    }
  }, []);

  const handleClose1 = () => {
    setStateSnackbar({ ...stateSnackbar, modalopen: false });
  };

  const getLicenseInfo = async () => {
    let internetAvailability = await checkInternet();
    console.log("internet", internetAvailability);

    if (
      internetAvailability.response.internet == false ||
      internetAvailability.response.internet == "false"
    ) {
      setIsColorFlag(false);
      setStateSnackbar({
        ...stateSnackbar,
        modalopen: true,
        snackbarMessage: "Internet connection required on server",
      });
      return false;
    }

    let params = {
      query: {
        site_uuid: userInfo.site_uuid,
      },
    };
    await getLatestCustomerLicense(params);
    dispatch(
      fetchSiteConfig({
        keyid: "site_config",
        site_uuid: userInfo.site_uuid,
      })
    );
    setIsColorFlag(true);
    setStateSnackbar({
      ...stateSnackbar,
      modalopen: true,
      snackbarMessage: "License updated successfully!",
    });
  };

  const setCurrentProduct = async (pro) => {
    console.log("pro", pro);
    setUpdateProductData(pro);
    setProductModalOpen(true);
  };

  const syncToWeb = async () => {
    dispatch(commonSliceActions.setLoader(true));
    let data = {};
    let params = {
      siteUuid: userInfo.site_uuid,
    };

    // this.$q.loading.show({
    //   message: 'Syncing...',
    // });

    let logsData = await syncDatabase(data, params);
    console.log("logsData", logsData);
    let logs = logsData.response;
    console.log("logs", logs);

    if (typeof logs == "string") {
      setIsColorFlag(false);
      setStateSnackbar({
        ...stateSnackbar,
        modalopen: true,
        snackbarMessage: logs,
      });
    } else {
      await userLogs({
        actor: userInfo.uid,
        verb: "sync",
        outcome: logs,
        site_uuid: userInfo.site_uuid,
      });
      setIsColorFlag(true);
      setStateSnackbar({
        ...stateSnackbar,
        modalopen: true,
        snackbarMessage: "Sync completed",
      });
    }
    dispatch(commonSliceActions.setLoader(false));
    // this.$q.loading.hide();
    let logName = await getLastSync();
    if (logName) {
      setLastSyncDate(logName.data.data[0].createdAt);
    }
  };

  const getLastSync = async () => {
    let params = {
      query: {
        verb: "sync",
        $sort: {
          created_at: -1,
        },
        site_uuid: userInfo.site_uuid,
        $limit: 1,
      },
    };
    console.log("params", params);
    let logName = await getUserLogs(params);
    console.log("logName", logName);
    return logName;
  };

  const productModalClose = () => {
    setProductModalOpen(false);
  };

  const handleRadioChange = (event) => {
    setProductUpdateType(event.target.value);
  };

  const handleSubmit = async () => {
    console.log("productUpdateType", productUpdateType);
    setProductModalOpen(false);

    // document.getElementById('loader').style.display = 'block';
    if (productUpdateType == "local") {
      await updateProduct();
    } else {
      let params = {
        query: {
          updateProduct: updateProductData,
          site_uuid: userInfo.site_uuid,
        },
      };
      let res = await productUpdateFromLive(params);
      let productVerifed = res.response;
      console.log("productVerifed", productVerifed);
      // document.getElementById('loader').style.display = 'none';

      setIsColorFlag(true);
      setStateSnackbar({
        ...stateSnackbar,
        modalopen: true,
        snackbarMessage: productVerifed.message,
      });

      if (productVerifed.status == 200) doMediaImportProgress();
    }
  };

  // product update from local
  const updateProduct = async () => {
    console.log(updateProductData, "=======");
    let params = {
      query: {
        productId: updateProductData.productId,
        productVersion: updateProductData.productVersion,
        site_uuid: userInfo.site_uuid,
        type: "update",
      },
    };
    let res = await verifyProductData({}, params);
    let productVerifed = res.response;
    let productVerifedArr = productVerifed.split("_");

    if (productVerifedArr[0] != "done") {
      setIsColorFlag(false);
      if (productVerifed == "productidfailed") {
        setStateSnackbar({
          ...stateSnackbar,
          modalopen: true,
          snackbarMessage: "Product id does not match.",
        });
      } else if (productVerifed == "productversionfailed") {
        setStateSnackbar({
          ...stateSnackbar,
          modalopen: true,
          snackbarMessage: "Product version does not match.",
        });
      } else if (productVerifed == "productnotavailable") {
        setStateSnackbar({
          ...stateSnackbar,
          modalopen: true,
          snackbarMessage: "Full product is unavailable.",
        });
      } else if (productVerifed == "productuptodate") {
        setStateSnackbar({
          ...stateSnackbar,
          modalopen: true,
          snackbarMessage: "Product is already up-to-date",
        });
      }
      return false;
    } else {
      await productUpdateFromLocal();
      let newData = siteConfig;

      // if(_.findIndex(newData.products,{'productId':updateProductData.productId}) != -1){
      //     let pos = _.findIndex(newData.products,{'productId':updateProductData.productId});
      //     newData.products[pos].productVersion = productVerifedArr[1];
      // }
      let params1 = {
        query: {
          keyid: "site_config",
          site_uuid: userInfo.site_uuid,
        },
      };
      await updateDefs(newData, params1);

      //document.getElementById('loader').style.display = 'none';
      setIsColorFlag(true);
      setStateSnackbar({
        ...stateSnackbar,
        modalopen: true,
        snackbarMessage: "Product updated successfully",
      });
    }
  };

  const doMediaImportProgress = async () => {
    setAllMediaImported(false);
    setMediaVerifiedModal(true);
    setProgressBarPercent(0);

    let mediaDoneInterval = setInterval(async () => {
      countProgress();
      console.log("TTTTTT", progressBarPercent);
      if (progressBarPercent == 100) {
        setAllMediaImported(true);
        setMediaVerifiedModal(false);
        clearInterval(mediaDoneInterval);
      }
    }, 5000);
  };

  const countProgress = async () => {
    let params = {
      query: { status: true, $limit: 0 },
    };
    let res = await fetchMedia(params);
    let medias_true = res.response;

    let params1 = {
      query: { $limit: 0 },
    };
    let res1 = await fetchMedia(params1);
    let medias_all = res1.response;

    if (medias_true.total > parseInt(Number(medias_all.total) / 100)) {
      //     this.$q.loading.hide();
      setProgressBarPercent(
        (Number(medias_true.total) * 100) / Number(medias_all.total)
      );
    }
  };

  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        alignItems: "center",
        px: 3,
        py: 3,
        mx: 20,
      }}
    >
      <Grid item xs={7} sx={{ px: 1 }}>
        <Typography
          fontSize={"2.2rem"}
          sx={{
            fontWeight: "900",
            py: 1,
            px: 2,
            color: "primary.main",
            "@media (min-width: 1636px)": {
              fontSize: "1.6rem",
            },
          }}
        >
          License Info
        </Typography>
      </Grid>
      <Grid
        item
        xs={7}
        sx={{
          pb: 2,
          px: 4,
          py: 4,
          border: 1,
          borderColor: "#cccccc",
          borderRadius: 5,
        }}
      >
        <Typography
          sx={{
            fontSize: "1.6rem",
            fontWeight: "800",
            color: "primary.main",
            "@media (min-width: 1636px)": {
              fontSize: "1.8rem",
            },
          }}
        >
          {siteConfig && siteConfig.customer && (
            <span>{siteConfig.customer.customerName}</span>
          )}
        </Typography>

        {/* 
                            Product Info,
                            This detail is display to all type of role,
                            Product Update button is only visible to hode and this functionality is only for offline
                        */}
        {siteConfig.products.map((pro, index) => {
          return (
            <Grid
              key={index}
              container
              gap={1}
              sx={{
                py: 1,
                flexDirection: "row",
                alignItems: "center",
                borderBottom: "1px solid #EFEFEF",
              }}
            >
              <Grid>
                <RadioButtonCheckedIcon
                  sx={{ fontSize: "1.6rem", color: "primary.main" }}
                />
              </Grid>
              <Grid>
                <Typography
                  fontSize={"1.2rem"}
                  sx={{
                    textAlign: "left",
                    fontWeight: "500",
                    color: "primary.main",
                    pt: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  {/* {pro.productName} */"Product"}
                </Typography>
                <Typography
                  fontSize={"0.8rem"}
                  sx={{
                    textAlign: "left",
                    fontWeight: "500",
                    color: "#AFAFAF",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <Box component="span" sx={{color:"primary.main"}}>Ver: {pro.productVersion}</Box>
                  <Box component="span" sx={{ paddingLeft: "20px;",color:"primary.main" }}>
                    Expires: {getFormatedDate(pro.expiryDate, "DD-MMM-YYYY")}
                  </Box>
                </Typography>
              </Grid>
              {serverRole !== "WEB_HOST" &&
                userInfo &&
                (userInfo.rolesInfo.title.toLowerCase() == "incharge" ||
                  userInfo.rolesInfo.title.toLowerCase() == "admin") && (
                  <Grid flex={1} sx={{ textAlign: "right" }}>
                    <IconButton
                      edge="end"
                      aria-label="select"
                      onClick={() => {
                        setCurrentProduct(pro);
                      }}
                    >
                      <BrowserUpdatedIcon
                        fontSize="small"
                        value="a"
                        name="radio-buttons"
                        sx={{
                          color: "#DB8829",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      />
                    </IconButton>
                  </Grid>
                )}
            </Grid>
          );
        })}

        {/* 
                License Info & Update 
                This button is only visisble to Hode and admin role. They can update license info detail
            */}
        {userInfo &&
          (userInfo.rolesInfo.title.toLowerCase() == "incharge" ||
            userInfo.rolesInfo.title.toLowerCase() == "admin") && (
            <Grid
              container
              gap={1}
              sx={{
                py: 1,
                flexDirection: "row",
                borderBottom: "1px solid #EFEFEF",
              }}
            >
              <Grid>
                <Typography
                  fontSize={"1rem"}
                  sx={{
                    fontWeight: "500",
                    color: "primary.main",
                    pt: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Licence info
                </Typography>
              </Grid>
              <Grid flex={1} sx={{ textAlign: "right" }}>
                <IconButton
                  edge="end"
                  aria-label="select"
                  onClick={getLicenseInfo}
                >
                  <FeedIcon
                    fontSize="small"
                    value="a"
                    name="radio-buttons"
                    sx={{
                      color: "#DB8829",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          )}

        {/* 
                Sync functionality
                This button is only visisble to Hode role 
                Sync button is only display in offline installation, button will appear if the isSync value is true
            */}
        {serverRole !== "WEB_HOST" &&
          userInfo &&
          userInfo.rolesInfo.title.toLowerCase() == "incharge" &&
          siteConfig.customer.syncData.isSync == true && (
            <Grid container gap={1} sx={{ pt: 1, flexDirection: "row" }}>
              <Grid>
                <Typography
                  fontSize={"1rem"}
                  sx={{
                    fontWeight: "500",
                    color: "primary.main",
                    pt: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Last synced on:
                </Typography>
                <Typography
                  fontSize={"1rem"}
                  sx={{
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#898989",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  {lastSyncDate && (
                    <span>
                      {getFormatedDateTime(lastSyncDate, "DD-MMM-YYYY HH:MM")}
                    </span>
                  )}
                </Typography>
              </Grid>
              <Grid flex={1} sx={{ textAlign: "right" }}>
                <IconButton edge="end" aria-label="select" onClick={syncToWeb}>
                  <SyncIcon
                    fontSize="small"
                    value="a"
                    name="radio-buttons"
                    sx={{
                      color: "#DB8829",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          )}
      </Grid>
      {/* Snackbar or alert modal */}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={2000}
        open={modalopen}
        onClose={handleClose1}
        message={snackbarMessage}
        key={vertical + horizontal}
        ContentProps={{
          classes: {
            root: isColorFlag ? classes.rootColor : classes.rootColor1,
          },
        }}
        sx={{ top: { xs: 90, sm: 0 } }}
      />

      {/* Product update modal */}
      <Box>
        <Modal open={productModalOpen} onClose={productModalClose}>
          <Box className={classes.Modal} sx={{}}>
            <Typography
              sx={{ fontWeight: "800", fontSize: "1.4rem", mt: 2, mx: 2 }}
            >
              {" "}
              Product Update From?
            </Typography>
            <hr />
            <RadioGroup
              value={productUpdateType}
              sx={{
                mt: 4,
                mx: 2,
                flexDirection: "row",
                justifyContent: "space-around",
              }}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="local"
                control={
                  <Radio
                    sx={{
                      color: grey[50],
                      "&.Mui-checked": { color: grey[50] },
                    }}
                  />
                }
                label="Local"
              />
              <FormControlLabel
                value="live"
                control={
                  <Radio
                    sx={{
                      color: grey[50],
                      "&.Mui-checked": { color: grey[50] },
                    }}
                  />
                }
                label="Live"
              />
            </RadioGroup>
            <Grid
              item
              sx={{
                flexDirection: "row",
                justifyContent: "space-around",
                mt: 3,
                borderTop: 1,
                borderTopColor: "#FFFFFF",
              }}
            >
              <Button
                onClick={handleSubmit}
                color="success"
                fullWidth
                variant="contained"
                sx={{
                  borderRadius: 10,
                  backgroundColor: "primary.success",
                  color: "#FFF",
                  fontWeight: "bold",
                  mt: 3,
                  px: 2,
                  width: "13em",
                }}
              >
                {" "}
                Save
              </Button>
              <Button
                onClick={productModalClose}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 10,
                  backgroundColor: "#FFFFFF",
                  color: "primary.main",
                  fontWeight: "bold",
                  mt: 3,
                  px: 2,
                  width: "13em",
                  ml: 4,
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Box>
        </Modal>
      </Box>
    </Grid>
  );
};

const useStyles = makeStyles({
  image: {
    width: "2.2rem",
    "@media (min-width: 1636px)": {
      width: "3rem",
    },
  },
  rootColor: {
    backgroundColor: "lightgreen",
    color: "black",
  },
  rootColor1: {
    backgroundColor: "orange",
    color: "black",
  },
  Modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: "32vh",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: "#DB8829",
    boxShadow: 24,
    color: "#FFFFFF",
    borderRadius: 30,
    padding: 20,
  },
});
export default LicenseInfo;
